import { useNotification } from '@/hooks';
import {
  useCreateOfficeMutation,
  useUpdateOfficeMutation,
} from '../services/offices.service';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { OfficeSchema } from '../models';
import { useNavigate } from 'react-router-dom';

const useOfficesActions = () => {
  const navigate = useNavigate();
  const [createOffice, { isLoading: isCreatingOffice }] =
    useCreateOfficeMutation();
  const [updateOffice, { isLoading: isUpdatingOffice }] =
    useUpdateOfficeMutation();

  const { showNotification } = useNotification();

  const onCreateOffice = async (data: OfficeSchema, reset: () => void) => {
    try {
      await createOffice(data).unwrap();
      showNotification(
        'Oficina creada correctamente',
        NotificationSeverity.success
      );
      reset();
      navigate('/inventory/geography/offices');
    } catch (error: any) {
      console.error(error);
      showNotification(
        'Ocurrió un error al crear la oficina. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
    }
  };

  const onUpdateOffice = async (
    id: string,
    data: OfficeSchema,
    reset: () => void
  ) => {
    try {
      await updateOffice({ id, body: data }).unwrap();
      showNotification(
        'Oficina actualizada correctamente',
        NotificationSeverity.success
      );
      reset();
      navigate('/inventory/geography/offices');
    } catch (error: any) {
      console.error(error);
      showNotification(
        'Ocurrió un error al actualizar la oficina. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
    }
  };

  return {
    isCreatingOffice,
    isUpdatingOffice,
    onCreateOffice,
    onUpdateOffice,
  };
};

export default useOfficesActions;
